import { jsxs as L, jsx as H } from "react/jsx-runtime";
const C = ({ size: V = 16, ...l }) => /* @__PURE__ */ L(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: V,
    height: V,
    viewBox: "0 0 35 24",
    fill: "none",
    ...l,
    children: [
      /* @__PURE__ */ L("g", { clipPath: "url(#clip0_974_133)", children: [
        /* @__PURE__ */ H("rect", { x: "0.5", y: "0.5", width: "34", height: "23", rx: "3.5", fill: "#006FCF", stroke: "#E5E7EB" }),
        /* @__PURE__ */ H(
          "path",
          {
            d: "M18.4429 15.1906C18.4429 15.4243 18.2857 15.6579 17.9714 15.6579H16.8714V14.8012H17.9714C18.2857 14.8012 18.4429 14.957 18.4429 15.1906Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ H(
          "path",
          {
            d: "M21.9786 14.8012C22.2929 14.8012 22.45 14.957 22.45 15.1906C22.45 15.4243 22.2929 15.5801 21.9786 15.5801H20.8786V14.8012H21.9786Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ H(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.1357 18.6176H33.1357C33.4511 18.6176 33.7314 18.5479 34 18.4318V17.5093C33.7826 17.6679 33.4927 17.7609 33.1357 17.7609H31.0929V16.9041H33.1357C33.2929 16.9041 33.45 16.8262 33.6071 16.6705C33.6071 16.5147 33.45 16.3589 33.2143 16.3589H32.2714C31.4857 16.3589 31.0143 15.8916 31.0143 15.1906C31.0143 14.4896 31.4857 13.9444 32.35 13.9444H34V13.1656H14.1214L13.5714 13.8666L13.0214 13.1656H7.28571V18.6176H13.0214L13.5714 17.8388L14.1214 18.6176H17.6571V17.3715H18.05C18.4429 17.3715 18.7571 17.2936 19.0714 17.2157V18.6176H21.4286V17.683L22.1357 18.6176ZM11.3714 14.8012V13.9444H8.15V17.8388H11.3714V17.7609H12.6286L13.5714 16.5147L14.5143 17.7609H15.7714L14.2 15.8137L15.7714 13.8666H14.5143L13.5714 15.0349L12.6286 13.8666H11.3714L12.9429 15.8137L11.3714 17.7609V16.982H9.17143V16.281H11.2929V15.4243H9.17143V14.8012H11.3714ZM15.85 17.7609H16.8714V16.5147H18.05C18.9143 16.5147 19.4643 15.9695 19.4643 15.1906C19.4643 14.4118 18.9143 13.8666 18.1286 13.8666H15.85V17.7609ZM20.8786 16.4368H21.2714L22.45 17.8388H23.7071L22.45 16.4368C23.0786 16.281 23.4714 15.8137 23.4714 15.1906C23.4714 14.4118 22.9214 13.9444 22.1357 13.9444H19.8571V17.8388H20.8786V16.4368ZM27.0071 14.8012V13.9444H23.7857V17.8388H27.0071V16.982H24.8071V16.281H26.9286V15.4243H24.8071V14.8012H27.0071ZM29.5214 16.9041H27.4786V17.7609H29.5214C30.3857 17.7609 30.8571 17.2157 30.8571 16.5147C30.8571 15.8137 30.3857 15.4243 29.6 15.4243H28.6571C28.4214 15.4243 28.3429 15.2685 28.3429 15.1127C28.3429 14.8791 28.5 14.8012 28.6571 14.8012H30.3857L30.7786 13.9444H28.7357C27.8714 13.9444 27.4 14.4896 27.4 15.1906C27.4 15.8916 27.8714 16.3589 28.6571 16.3589H29.6C29.8357 16.3589 29.9929 16.5147 29.9929 16.6705C29.8357 16.8262 29.6786 16.9041 29.5214 16.9041Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ H(
          "path",
          {
            d: "M34 14.8012L34 15.6085C33.7958 15.4874 33.5305 15.4243 33.2143 15.4243H32.2714C32.0357 15.4243 31.8786 15.2685 31.8786 15.1127C31.8786 14.8791 32.0357 14.8012 32.2714 14.8012H34Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ H("path", { d: "M3.35714 7.7135L2.80714 9.03757H3.90714L3.35714 7.7135Z", fill: "white" }),
        /* @__PURE__ */ H(
          "path",
          {
            d: "M17.6571 8.02505C17.6571 7.79139 17.5 7.63561 17.1857 7.63561H16.0857V8.41448H17.1857C17.5 8.41448 17.6571 8.25871 17.6571 8.02505Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ H("path", { d: "M25.2 7.7135L24.65 9.03757H25.75L25.2 7.7135Z", fill: "white" }),
        /* @__PURE__ */ H(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 11.53H2.65L2.96429 10.7511H3.67143L3.98571 11.53H16.7143V10.5953L17.4214 11.4521H20.8786V10.9847C21.35 11.3742 21.9786 11.4521 22.5286 11.4521H24.5714L24.8857 10.6732H25.5929L25.9071 11.4521H29.2857V10.5174L29.9929 11.4521H32.4286V6H29.9929V7.01253L29.3643 6H27.0857V7.40196L26.4571 6H22.6857C21.9786 6 21.4286 6.23366 20.9571 6.54521V6H8.7L8.30714 7.09041L7.91428 6H5.08571V7.40196L4.45714 6H2.17857L1 8.64815V10.6732V11.53ZM1 10.6732H2.1L2.41429 9.89433H4.22143L4.53571 10.6732H5.63571L3.98571 6.77886H2.65L1 10.6732ZM8.62143 10.6732H7.75714L6.81428 7.79139V10.6732H5.79286V6.77886H7.36428L8.22857 9.27123L9.09285 6.77886H10.6643V10.6732H9.64285V7.79139L8.62143 10.6732ZM14.5929 6.77886V7.63561H12.3929V8.25871H14.5143V9.11546H12.3929V9.81644H14.5929V10.6732H11.3714V6.77886H14.5929ZM16.4786 9.27123H16.0857L16.1643 10.6732H15.1429V6.77886H17.3428C18.1286 6.77886 18.6786 7.24618 18.6786 8.02505C18.6786 8.64814 18.2857 9.11546 17.6571 9.27123L18.9143 10.6732H17.6571L16.4786 9.27123ZM20.0929 10.6732H19.0714V6.77886H20.0929V10.6732ZM22.8428 9.81644L22.3714 10.6732C21.2714 10.6732 20.5643 9.97221 20.5643 8.80391V8.72603C20.5643 7.55773 21.1929 6.77886 22.45 6.77886H23.55V7.7135H22.5286C21.8214 7.7135 21.5071 8.10293 21.5071 8.72603V8.80391C21.5071 9.42701 21.9 9.81644 22.5286 9.81644H22.8428ZM27.5571 10.6732H26.4571L26.1428 9.89433H24.3357L24.0214 10.6732H22.9214L24.5714 6.77886H25.9071L27.5571 10.6732ZM31.4071 10.6732H30.2286L28.5786 8.18082V10.6732H27.5571V6.77886H28.8143L30.3857 9.19335V6.77886H31.4071V10.6732Z",
            fill: "white"
          }
        )
      ] }),
      /* @__PURE__ */ H("defs", { children: /* @__PURE__ */ H("clipPath", { id: "clip0_974_133", children: /* @__PURE__ */ H("rect", { width: "35", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  C as AmericanExpressIcon
};
